import {
  ArrowDown,
  ArrowUp,
  MinusCircle,
} from "@hl/base-components/lib/assets/icons/HDS";
import { ActionIcon, Box, Button, Group, Stack, Text } from "@mantine/core";
import { PropertyStack } from "grapesjs";

import { CustomStylePropertyField } from "../style-manager/CustomStylePropertyField";

export const StackedPropertyFields = (props: { property: PropertyStack }) => {
  const { property } = props;

  const layers = property.getLayers();
  // Can be used to preview the style of the text-shadow
  // const isTextShadow = property.getName() === "text-shadow";

  if (layers.length === 0) {
    return <></>;
  } else {
    return (
      <Stack
        sx={
          {
            // border: "1px solid transparent",
            // borderRadius: 12,
            // background: "var(--mantine-color-gray-2)",
            // padding: "10px",
          }
        }
        spacing={8}
      >
        {layers.map((layer) => (
          <Box
            key={layer.getId()}
            sx={{
              border: "1px solid transparent",
              borderRadius: 12,
              background: "var(--mantine-color-gray-2)",
              padding: "4px 10px",
            }}
          >
            <Group spacing={8} noWrap>
              <ActionIcon
                bg={"transparent"}
                size={18}
                c={"gray.5"}
                onClick={() => layer.move(layer.getIndex() - 1)}
              >
                <ArrowUp />
              </ActionIcon>

              <ActionIcon
                bg={"transparent"}
                size={18}
                c={"gray.5"}
                onClick={() => layer.move(layer.getIndex() + 1)}
              >
                <ArrowDown />
              </ActionIcon>

              <Button
                color="secondary"
                sx={{
                  background: layer.isSelected()
                    ? "var(--mantine-color-white)"
                    : "transparent",
                  padding: "4px 8px",
                  width: "100%",
                  overflow: "hidden",
                }}
                onClick={() => layer.select()}
              >
                <Text
                  fz={14}
                  sx={{
                    maxWidth: "100%",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {layer.getLabel()}
                </Text>
              </Button>
              {/* <Box
                      style={layer.getStylePreview({
                        number: { min: -3, max: 3 },
                        camelCase: true,
                      })}
                    >
                      {isTextShadow && "T"}
                    </Box> */}

              <ActionIcon
                bg={"transparent"}
                size={18}
                c={"red.5"}
                onClick={() => layer.remove()}
              >
                <MinusCircle />
              </ActionIcon>
            </Group>

            {layer.isSelected() && (
              <Box
                sx={{
                  padding: "10px",
                  background: "var(--mantine-color-white)",
                  borderRadius: 10,
                }}
              >
                <Stack>
                  {property.getProperties().map((prop) => (
                    <CustomStylePropertyField key={prop.getId()} prop={prop} />
                  ))}
                </Stack>
              </Box>
            )}
          </Box>
        ))}
      </Stack>
    );
  }
};
